// Auto generated file, do not manually modify!
// com.hotpads.admanagement.client.enums.AdManagementSalesforceSubscriptionProductStatus

export enum AdManagementSalesforceSubscriptionProductStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  EXPIRED = 'EXPIRED',
  PAUSED = 'PAUSED',
  PENDING = 'PENDING',
  PENDING_CANCELLATION = 'PENDING_CANCELLATION',
  PENDING_PAUSE = 'PENDING_PAUSE',
  PENDING_UNPAUSE = 'PENDING_UNPAUSE',
  SUSPENDED = 'SUSPENDED',
  UNPAUSED = 'UNPAUSED',
}

export const AdManagementSalesforceSubscriptionProductStatus_values = [
  AdManagementSalesforceSubscriptionProductStatus.ACTIVE,
  AdManagementSalesforceSubscriptionProductStatus.CANCELLED,
  AdManagementSalesforceSubscriptionProductStatus.EXPIRED,
  AdManagementSalesforceSubscriptionProductStatus.PAUSED,
  AdManagementSalesforceSubscriptionProductStatus.PENDING,
  AdManagementSalesforceSubscriptionProductStatus.PENDING_CANCELLATION,
  AdManagementSalesforceSubscriptionProductStatus.PENDING_PAUSE,
  AdManagementSalesforceSubscriptionProductStatus.PENDING_UNPAUSE,
  AdManagementSalesforceSubscriptionProductStatus.SUSPENDED,
  AdManagementSalesforceSubscriptionProductStatus.UNPAUSED,
] as const;
